/* Maison Fianchetto (19/10, v3) : sur écran tactile, glisser la photo d'une carte produit pour voir la 2e photo.
   Sur ordinateur, la 2e photo apparaît au survol (inchangé).
   - fichier à part, syntaxe simple : il ne dépend d'aucun autre script et fonctionne sur les anciens iPhone ;
   - écran tactile détecté directement (pas seulement le réglage « survol » du navigateur) ;
   - le doigt est écouté au niveau de la page : aucune couche de la carte (lien, badges) ne peut l'intercepter ;
   - la photo suit le doigt puis se cale sur la 1re ou la 2e image ; deux points indiquent laquelle est affichée ;
   - un appui simple ouvre la fiche, comme avant ;
   - seulement dans les grilles (collections, recherche) : dans les rangées qui défilent, le geste fait défiler la rangée. */
(function () {
  var touch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) ||
    (window.matchMedia && window.matchMedia('(hover: none)').matches);
  if (!touch) return;
  document.documentElement.classList.add('mf-touch');

  function setup() {
    var cards = document.querySelectorAll('.product-grid .card-wrapper');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.getAttribute('data-mf-swipe')) continue;
      card.setAttribute('data-mf-swipe', '1');
      if (card.closest('.slider, slider-component, .mf-rail')) continue;
      var media = card.querySelector('.card__media .media.media--hover-effect');
      if (!media) continue;
      var imgs = media.querySelectorAll(':scope > img');
      if (imgs.length < 2) continue;
      var dots = document.createElement('span');
      dots.className = 'mf-card-dots';
      dots.setAttribute('aria-hidden', 'true');
      dots.innerHTML = '<i class="is-on"></i><i></i>';
      card.querySelector('.card__media').appendChild(dots);
      // 19/10 (retour cliente : « au changement de page, la deuxième image glisse ») : la mise en place est instantanée,
      // l'animation ne sert qu'au glissement du doigt
      card.classList.add('mf-swipe-init', 'mf-card-swipe');
      // 27/10 (audit affichage) : le suivi du doigt qui peut bloquer le défilement est posé sur la carte seulement,
      // plus sur toute la page (sinon chaque défilement, partout sur le site, attendait ce script)
      (card.closest('.grid__item') || card).addEventListener('touchmove', onMove, { passive: false });
      (function (c) { requestAnimationFrame(function () { requestAnimationFrame(function () { c.classList.remove('mf-swipe-init'); }); }); })(card);
    }
  }

  function show(card, second) {
    var media = card.querySelector('.media.media--hover-effect');
    card.classList.toggle('mf-card-alt', second);
    media.style.removeProperty('--mf-x');
    var d = card.querySelectorAll('.mf-card-dots i');
    if (d.length === 2) { d[0].classList.toggle('is-on', !second); d[1].classList.toggle('is-on', second); }
  }

  var cur = null; // geste en cours : { card, media, x0, y0, w, dir, base }
  var lastSwipe = 0;

  document.addEventListener('touchstart', function (e) {
    cur = null;
    var t = e.touches[0];
    var cards = document.querySelectorAll('.mf-card-swipe');
    for (var i = 0; i < cards.length; i++) {
      var box = cards[i].querySelector('.card__media');
      var r = box.getBoundingClientRect();
      if (t.clientX >= r.left && t.clientX <= r.right && t.clientY >= r.top && t.clientY <= r.bottom) {
        var media = cards[i].querySelector('.media.media--hover-effect');
        cur = { card: cards[i], media: media, x0: t.clientX, y0: t.clientY, w: r.width, dir: null,
          base: cards[i].classList.contains('mf-card-alt') ? -r.width : 0 };
        break;
      }
    }
  }, { passive: true, capture: true });

  // posé sur chaque carte dans setup() (touchmove arrive à l'élément touché au départ, donc à sa carte)
  function onMove(e) {
    if (!cur) return;
    var t = e.touches[0];
    var dx = t.clientX - cur.x0, dy = t.clientY - cur.y0;
    if (!cur.dir) {
      if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
      cur.dir = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      if (cur.dir === 'x') cur.card.classList.add('mf-card-dragging');
    }
    if (cur.dir !== 'x') return;
    if (e.cancelable) e.preventDefault(); // la page ne défile pas pendant qu'on fait glisser la photo
    var x = Math.max(-cur.w, Math.min(0, cur.base + dx));
    cur.media.style.setProperty('--mf-x', x + 'px');
  }

  document.addEventListener('touchend', function (e) {
    if (!cur) return;
    var c = cur;
    cur = null;
    c.card.classList.remove('mf-card-dragging');
    if (c.dir !== 'x') return;
    var dx = e.changedTouches[0].clientX - c.x0;
    var second = c.base === 0 ? dx < -c.w * 0.18 : !(dx > c.w * 0.18);
    show(c.card, second);
    lastSwipe = Date.now();
  }, { passive: true, capture: true });

  // après un glissement, le doigt levé ne doit pas ouvrir la fiche
  document.addEventListener('click', function (e) {
    if (Date.now() - lastSwipe < 500 && e.target.closest && e.target.closest('.mf-card-swipe')) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  /* 19/10 (refonte, retour cliente : « pouvoir swiper pour voir la 2e image, comme pour les autres ») :
     carte vedette des collections (snippets/mf-card-feature) : glisser la photo affiche la 2e photo, et inversement. */
  function setupFeat() {
    var feats = document.querySelectorAll('.mf-feat');
    for (var i = 0; i < feats.length; i++) {
      var f = feats[i];
      if (f.getAttribute('data-mf-swipe') || !f.querySelector('.mf-feat__alt')) continue;
      f.setAttribute('data-mf-swipe', '1');
      var d = document.createElement('span');
      d.className = 'mf-feat__dots';
      d.setAttribute('aria-hidden', 'true');
      d.innerHTML = '<i class="is-on"></i><i></i>';
      f.querySelector('.mf-feat__media').appendChild(d);
      f.addEventListener('touchmove', onFeatMove, { passive: false }); // 27/10 : sur la carte seulement, pas sur toute la page
    }
  }
  var fs = null;
  document.addEventListener('touchstart', function (e) {
    fs = null;
    var m = e.target.closest && e.target.closest('.mf-feat__media');
    if (!m || !m.querySelector('.mf-feat__alt')) return;
    fs = { feat: m.closest('.mf-feat'), x0: e.touches[0].clientX, y0: e.touches[0].clientY, dir: null };
  }, { passive: true, capture: true });
  function onFeatMove(e) {
    if (!fs) return;
    var dx = e.touches[0].clientX - fs.x0, dy = e.touches[0].clientY - fs.y0;
    if (!fs.dir) {
      if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
      fs.dir = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
    }
    if (fs.dir === 'x' && e.cancelable) e.preventDefault();
  }
  document.addEventListener('touchend', function (e) {
    if (!fs) return;
    var c = fs;
    fs = null;
    if (c.dir !== 'x') return;
    var dx = e.changedTouches[0].clientX - c.x0;
    if (Math.abs(dx) < 30) return;
    var alt = dx < 0;
    c.feat.classList.toggle('mf-feat--alt', alt);
    var dots = c.feat.querySelectorAll('.mf-feat__dots i');
    if (dots.length === 2) { dots[0].classList.toggle('is-on', !alt); dots[1].classList.toggle('is-on', alt); }
    lastSwipe = Date.now();
  }, { passive: true, capture: true });
  document.addEventListener('click', function (e) {
    if (Date.now() - lastSwipe < 500 && e.target.closest && e.target.closest('.mf-feat')) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  function setupAll() { setup(); setupFeat(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupAll);
  else setupAll();
  // grilles rechargées (filtres, tri, pages suivantes)
  new MutationObserver(setupAll).observe(document.documentElement, { childList: true, subtree: true });
})();
